module.exports = __webpack_public_path__ + "img/Modelo-Catalina-Club-BG.cedda2d1.jpg";